// extracted by mini-css-extract-plugin
module.exports = {"container":"MovieDetailsScreen_container__dY9WN","content":"MovieDetailsScreen_content__VwBza","cover":"MovieDetailsScreen_cover__fXCMX"};